import React from 'react';

import { Container, Jumbotron } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCoins } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

export const Home: React.FC = () => {
  return (
    <Jumbotron className="mb-4">
      <Container className="p-4" fluid>
        <h1 className="display-3 mr-3 d-inline">
          <FontAwesomeIcon icon={faCoins} className="mr-5" />
          <FormattedMessage id="home_title" />
        </h1>
        <p className="lead mt-4">
          <FormattedMessage id="home_welcome" />
        </p>
        <hr className="my-2" />
        <p>
          <FormattedHTMLMessage id="home_welcome_sub" />
        </p>
      </Container>
    </Jumbotron>
  );
};
